
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  commonModule,
  actionTypesModule,
  itemsModule,
  companyModule,
  installationsModule,
  jobsModule,
  paymentsModule,
  filterModule,
} from "@/store/modules/store-accessor";
import { calculateTimeChargingCost, getOptimalTextColor, installationPhotoCompressionSettings, isDecimalNumber, paymentClientsOptions, primaryInstallationItemText, timeChargedUnitLabels } from "@/helpers/data";
import AssigneeCombo from "@/components/Combobox/AssigneeCombo.vue";
import AssigneeMultiUserCombo from "@/components/Combobox/AssigneeMultiUserCombo.vue";
import LabelCombo from '@/components/Combobox/LabelCombo.vue';
import InstallationItemWarrantyIndicator from "@/components/InstallationItemWarrantyIndicator.vue";
import { greekSearchFilter } from "@/helpers/data";
import PaymentAllocation from '@/components/Payments/PaymentAllocation.vue';

import _, { isNumber } from "lodash";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TimeUtil } from "@/helpers/TimeUtil";
import imageCompression from "browser-image-compression";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    AssigneeCombo,
    AssigneeMultiUserCombo,
    LabelCombo,
    InstallationItemWarrantyIndicator,
    PaymentAllocation,
  },
})
export default class QuickAddJob extends Vue {
  @Prop() readonly step: number;
  @Prop() readonly currentStep: any;
  @Prop() readonly installation: any;

  greekSearchFilter = greekSearchFilter;

  date = false;
  time = false;
  addJobLoading = false;
  assigneeLoading = false;
  actionLoading = false;
  isCompleted = false;
  dateMenu = false;
  loadingInstallationPrimaryItems = true;
  addMaterials = false;
  addExpenses = false;
  installationInfo = {} as Record<string, any>;
  scheduledTimeMenu = false;

  scheduled_start_time = this.formatCurrentTime(new Date());

  jobModel = {
    created_at: this.formatDate(new Date()),
    created_at_date: dayjs().format('YYYY-MM-DD'),
    created_at_time: dayjs().format('HH:mm'),
    type_id: [] as any[],
    materials: [
      {
        id: Math.random() * -1, //Need Random and non-integer and also negative, for this to work with the backend properly
        cost: 0, //This needs to be initialized not null for the reduce to work
        description: '',
        notes: '',
        unit_quantity: '1',
        unit_cost: 0,
        unit: null,
        is_unit_based: false,
        inventory_item_id: null,
      }] as any,
    assignee_id: '',
    installation_id: '',
    is_complete: false,
    notes: '',
    payment_amount: 0,
    is_paid: false,
    radioValue: 'user',
    payment_type: this.paymentTypesCombo[0],
    task_id: null,
    partner_id: '',
    installation_item_id: {},
    expenses: [{
      id: Math.random() * -1, //Need Random and non-integer and also negative, for this to work with the backend properly
      cost: 0,
      notes: '',
      expense_label_id: null,
    }] as any,
    description: '',
    payments: [
      {
        id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
        amount: 0, // This needs to be initialized not null for the reduce to work
        payment_type: this.paymentTypesCombo[0],
        notes: '',
        client_paid: this.paymentPersonOptions[0],
      }] as any,
  }

  photoModel = {
    add_photo: false,
    photos: [] as File[],
    notes: '',
    urls: [] as string[],
    previewUrls: [] as string[],
  };

  scheduledDateRule = [
    (val: any) => !!val || this.$i18n.t('scheduled_day_required'),
  ];

  userRule = [(val: any) => !!val || this.$i18n.t('user_required')];

  scheduledTimeRule = [
    (val: any) => !!val || this.$i18n.t('scheduled_time_required'),
  ];

  durationRule = [(val: any) => !!val || this.$i18n.t('duration_required')];

  typeRule = [
    (val: any) => (val || "").length > 0 || this.$i18n.t('actions_required'),
  ];

  installationRule = [
    (val: any) => !!val || this.$i18n.t('installation_required'),
  ];

  notesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t('notesLengthRule');
      else return true;
    },
  ];

  costRule: any = [
    (val: any) => {
      if (val === "" || isNaN(val)) {
        return this.$i18n.t('cost_required');
      }
      return val >= 0 || this.$i18n.t('cost_required');
    },
  ];

  titleRule = [
    (val: any) => !!val || this.$i18n.t('title_required'),
    (val: any) => val.length <= 300 || this.$i18n.t('form_title_length_rule'),
  ];

  jobDescriptionRule = [
    (val: any) => val.length <= 80 || this.$i18n.t('jobDescriptionLengthRule'),
  ];

  descriptionRule = [
    (val: any) =>
      val == null ||
      val?.text?.length <= 80 ||
      val?.length <= 80 ||
      this.$i18n.t('client_form_description_length_rule'),
  ];

  materialsNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t('notesLengthRule');
      else return true;
    },
  ];

  expenseNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 30 || this.$i18n.t('expenseNotesLengthRule');
    },
  ];

  actionNotesRule = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ];

  itemUnitRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t('unitOptionRule'),
  ]

  itemUnitCostRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t('requiredRule'),
  ]

  paymentTypeRule = [
    (val: any) => (val || "").id > 0 || this.$i18n.t('payment_type_required'),
  ];

  photoRules = [
    (val: any) => val && val.length >= 1 || this.$t('photosRequired'),
    (val: any) => val && val.length <= 30 || this.$t('photoLengthRule'),
  ];
  photoNotesRule = [
    (val: any) => val.length <= 50 || this.$i18n.t('notesForPhotoRule'),
  ];

  nextEventRule = [(val: any) => !!val || this.$i18n.t('nextEventRuleText')];

  reminderRule = [
    (val: any) => (val !== "" && val >= 0) || this.$i18n.t("reminderRuleText"),
  ];

  reminderOptionRule = [
    (val: any) =>
      ((!!val || val == "") && val.text.length > 0) ||
      this.$i18n.t("reminderOptionRuleText"),
  ];

   unitOptionRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]

  unitQuantityRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("unitOptionRule"),
  ]

  unitRule = [
    (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t("requiredRule"),
  ]

  actualCostRule: any = [];

  itemUnitQuantityRules(index: number) {
    return [
      (val: any) => (val !== null && val !== "" && val >= 0) || this.$i18n.t('requiredRule'),
      (val: any) => {
        const currentMaterial = this.jobModel.materials[index];
        if (currentMaterial && currentMaterial.unit.enum_text === 'PIECES') {
          const valToString = String(val);
          if (valToString.includes('.') || valToString.includes(',')) {
            return this.$i18n.t('itemUnitPiecesDecimalWarning');
          }
        }
        return true;
      }
    ];
  }

  get jobTotalCost() {
    let actionTotal = this.jobModel.type_id?.reduce(
      (accumulator: number, item: any) => {
        return (
          accumulator +
          (!isNaN(parseFloat(item.cost)) ? parseFloat(item.cost) : 0)
        );
      },
      0
    );
    let materialTotal = this.jobModel.materials?.reduce(
      (accumulator: number, item: any) => {
        return (
          accumulator +
          (!isNaN(parseFloat(item.cost)) ? parseFloat(item.cost) : 0)
        );
      },
      0
    );

    let total = actionTotal;

    if (this.addMaterials) total += materialTotal;

    return total;
  }


  addMaterial() {
    let newMaterial = {
      id: Math.random() * -1,
      cost: 0, //This needs to be initialized not null for the reduce to work
      description: '',
      notes: '',
      unit_quantity: '1',
      unit_cost: 0,
      unit: null,
      is_unit_based: false,
      inventory_item_id: null,
    } as any

    this.jobModel.materials.push(newMaterial);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deleteMaterial(index: number) {
    if (this.jobModel.materials.length > 1) {
      this.jobModel.materials.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  addExpense() {
    let newExpense = {
      id: Math.random() * -1,
      cost: 0,
      notes: "",
      expense_label_id: null,
    } as any;

    this.jobModel.expenses.push(newExpense);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deleteExpense(index: number) {
    if (this.jobModel.expenses.length > 1) {
      this.jobModel.expenses.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  onActionTypeChange(ev: any) {
    this.jobModel.type_id.map((item) => {
      item.next_task = item.is_periodic
        ? dayjs(this.jobModel.created_at_date)
          .startOf('day')
          .add(item.periodic_days, 'days')
          .format('YYYY-MM-DD')
        : null;
    });
  }

  get durationCombo() {
    return commonModule.durationCombo;
  }

  get inventoryItemsCombo() {
    return commonModule.inventoryItemsCombo;
  }

  get actionsCombo() {
    return actionTypesModule.actionTypesCombo;
  }

  get installationsCombo() {
    return commonModule.installationsCombo;
  }

  get isAssigneeLoading() {
    return this.assigneeLoading;
  }

  get isActionsLoading() {
    return this.actionLoading;
  }

  get installationPrimaryItems() {
    return itemsModule.installationPrimaryItems;
  }

  primaryItemText(item: Record<string, any>) {
    return primaryInstallationItemText(item);
  }

  get isLoadingInstallationPrimaryItems() {
    return this.loadingInstallationPrimaryItems;
  }

  get timeChargedUnitCombo() {
    return commonModule.timeChargedUnitCombo;
  }

  get disablePrimaryItems() {
    return (
      this.loadingInstallationPrimaryItems ||
      this.installationPrimaryItems.length === 0
    );
  }

  get isLoadingItems() {
    return itemsModule.loadingItemsCombo;
  }

  get paymentTypesCombo() {
    return commonModule.paymentTypeCombo;
  }

  get periodicCombo() {
    return commonModule.periodicCombo;
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  formatDate(date: Date): string {
    return TimeUtil.formatDateOnly(date);
  }

  onlyNumbers(evt: any) {
    isNumber(evt);
  }

  timeChargedUnitLabels(unit: Record<string, any>) {
    return timeChargedUnitLabels(unit?.unit);
  }


  @Watch('currentStep')
  async stepUpdate() {
    if (this.currentStep == this.step) {
      if (this.installation.id != -1) {
        this.assigneeLoading = true;
        this.installationInfo = await installationsModule.getInstallationDetailsInfo(this.installation.id);

        // Need this in order to load the client_paid for the first payment
        if (!this.jobModel.payments[0].client_paid && this.paymentPersonOptions.length) {
          this.jobModel.payments[0].client_paid = this.paymentPersonOptions[0];
        }

        await commonModule.getPersonnelCombo();
        this.assigneeLoading = false;

        await itemsModule.getInstallationPrimaryInventoryItems(this.installation.id);
        this.jobModel.installation_item_id = this.defaultInstallationItem();
        this.loadingInstallationPrimaryItems = false;

        this.actionLoading = true;
        await commonModule.getActionCombo();
        await commonModule.getDurationCombo();
        await actionTypesModule.getActionTypesCombo();
        await actionTypesModule.getActionTypesCombo();
        await commonModule.getPaymentTypeCombo();
        await commonModule.getItemTypeCombo();
        await commonModule.getPersonnelPartnersCombo();
        await itemsModule.getAllInventoryItems('');
        await commonModule.getPeriodicCombo(1);
        await itemsModule.getAllCompanyPrimaryInventoryItems();
        await commonModule.getTimeChargedUnitCombo();
        await itemsModule.getItemsUnitsCombo();
        await commonModule.getItemsCombo();
        await commonModule.getExpenseLabelsCombo();
        this.actionLoading = false;
      }
    }
  }

  updateAssignee(assignee: any) {
    this.jobModel.assignee_id = assignee;
  }

  onlyDecimalNumbers(evt: any) {
    isDecimalNumber(evt);
  }

  async endStep() {
    const paymentAllocation = this.$refs.paymentAllocation as PaymentAllocation;
    const isPaymentAllocationValid = !this.jobModel.is_paid || (!!paymentAllocation && paymentAllocation.validate());

    if ((this.$refs.form as Vue & { validate: () => boolean }).validate() && isPaymentAllocationValid) {
      this.addJobLoading = true;

      let job = _.cloneDeep(this.jobModel);

      this.typeRule = [];
      job.installation_id = this.installationInfo.info.id;

      job.created_at = dayjs(this.jobModel.created_at_date + " " + this.jobModel.created_at_time).utc().format('DD MMM YYYY HH:mm:ss');

      if (this.addMaterials) {
        job.materials = job.materials.map((material: any) => {
          if (typeof material.description === 'object' && material.description != null) {
            material.description = material.description.text
            material.unit = material.unit.enum_text
            return material
          }
          else {
            return material
          }
        })
      }
      else {
        delete job.materials
      }

      if (!this.addExpenses) {
        delete job.expenses;
      }

      const companyTimezone = companyModule.company?.timezone || dayjs.tz.guess();
      job.type_id.map((item) => {
        item.due_at = item.is_periodic
          ? dayjs
              .tz(item.next_task, companyTimezone)
              .startOf("day")
              .subtract(
                parseInt(item.reminder_option_value) *
                  item.reminder_option_combo.period,
                "days"
              )
              .endOf("day")
              .toISOString()
          : null;
      });

      const jobId: any = await jobsModule.createJobWithActions(job);

      if (this.photoModel.add_photo && this.photoModel.photos.length > 0) {
        const formData = new FormData();
        for (const file of this.photoModel.photos) {
          formData.append('image', file);
        }

        formData.append('notes', this.photoModel?.notes?.trim());
        formData.append('job_id', jobId.id);

        await installationsModule.addInstallationPhoto({ installationId: job.installation_id, photo: formData });
      }

      switch (this.$route.name) {
        case 'Jobs':
          jobsModule.getJobs(jobsModule.filters);
          jobsModule.getJobTotals(jobsModule.filters);
          break;
        case 'Installations':
          installationsModule.getInstallationsAction(installationsModule.filters);
          break;
        case 'My Company':
          await paymentsModule.getPaymentsAction(paymentsModule.filters);
          await paymentsModule.getPaymentsTotals(paymentsModule.filters);
          await filterModule.getPaymentsAndExpensesFilters();
          break;
      }

      this.addJobLoading = false;
      this.$emit('close-modal');
    }
  }

  defaultInstallationItem() {
    if (this.installationPrimaryItems && this.installationPrimaryItems.length === 1) {
      return this.installationPrimaryItems[0];
    }
    return { primary_items: '', id: 0 };
  }

  formatCurrentTime(date: Date): string {
    return TimeUtil.formatTimeOnly(date);
  }

  prevStep() {
    this.$emit('prev-step');
  }

  get jobDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.job_description;
  }

  get itemsUnitsTypes() {
    return itemsModule.itemsUnitsCombo;
  }

  itemUnitNumberInputs(evt: Record<string, any>, item: Record<string, any>) {
    if (item.unit.decimals) {
      return isDecimalNumber(evt);
    }
    return isNumber(evt)
  }

  findItemUnit(unitType: Record<string, any>, index: number, material: Record<string, any>) {
    let unitCombo: any = itemsModule.itemsUnitsCombo;
    const foundUnitType = (unitCombo).find((item: any) => item.enum_text == unitType.unit);
    material.unit = { text: foundUnitType?.text, enum_text: foundUnitType?.enum_text, decimals: foundUnitType?.decimals } as any;
    material.is_unit_based = unitType.is_unit_based ?? false;
    material.unit_cost = unitType.cost ?? null;
    material.cost = unitType.cost ?? 0;
    material.unit_quantity = unitType.is_unit_based ? 1 : null;
    material.inventory_item_id = unitType.inventory_item_id ?? null;
  }

  calcItemUnitCost(index: number) {
    this.jobModel.materials[index].cost = (this.jobModel.materials[index].unit_cost * this.jobModel.materials[index].unit_quantity).toFixed(2);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  repayment() {
    const remainingAmount = Number(this.jobTotalCost) - this.paymentsTotal;

    const lastPaymentIndex = this.jobModel.payments.length - 1;
    const lastPaymentAmount = Number(this.jobModel.payments[lastPaymentIndex].amount || 0);

    if (lastPaymentAmount === 0) {
      this.jobModel.payments[lastPaymentIndex].amount = remainingAmount;
      this.$nextTick(() => this.validatePaymentAmounts());
      return;
    }

    this.jobModel.payments.push({
      id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
      amount: remainingAmount,
      payment_type: this.paymentTypesCombo[0],
      notes: '',
      client_paid: this.paymentPersonOptions[0],
    });
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  validatePaymentAmounts() {
    this.jobModel.payments.forEach((_: Record<string, any>, index: number) => {
      const ref = this.$refs[`paymentAmount_${index}`];
      const field = Array.isArray(ref) ? ref[0] : ref;
      if (field && typeof (field as Record<string, any>).validate === 'function') {
        (field as Record<string, any>).validate();
      }
    });
  }

  addPayment() {
    let newPayment = {
      id: Math.random() * -1, // Need Random and non-integer and also negative, for this to work with the backend properly
      amount: 0, // This needs to be initialized not null for the reduce to work
      payment_type: this.paymentTypesCombo[0],
      notes: '',
      client_paid: this.paymentPersonOptions[0],
    } as any

    this.jobModel.payments.push(newPayment);
    this.$nextTick(() => this.validatePaymentAmounts());
  }

  deletePayment(index: number) {
    if (this.jobModel.payments.length > 1) {
      this.jobModel.payments.splice(index, 1);
      this.$nextTick(() => this.validatePaymentAmounts());
    }
  }

  get paymentPersonOptions() {
    return Object.keys(this.installationInfo).length > 0 ? paymentClientsOptions({ installation: this.installationInfo }) : [];
  }

  get paymentClientsCombo() {
    const info = this.installationInfo.info;
    if (!info) return [];

    return this.paymentPersonOptions.map((client: Record<string, any>) => ({
      id: client.value === 'user' ? info.user_id : info.owner_id,
      name: client.label,
      is_business: client.value === 'user' ? info.client_is_business : info.owner_is_business,
    }));
  }

  updatePayments(payments: JobPaymentRequestDto[]) {
    this.jobModel.payments = payments as any;
  }

  get paymentsTotal() {
    return this.jobModel.payments.reduce((sum: number, payment: Record<string, any>) => sum + Number(payment.amount), 0);
  }

  get enableRepayment() {
    return Number(this.jobTotalCost) > 0 && Number(this.jobTotalCost) > Number(this.paymentsTotal);
  }

  get paymentRule() {
    return [
      (val: any) => {
        if (val === "" || isNaN(val)) {
          return this.$i18n.t("nonZeroPaymentRule");
        }
        return val > 0 || this.$i18n.t("nonZeroPaymentRule");
      },
      (val: any) => {
        return this.paymentsTotal <= this.jobTotalCost || this.$i18n.t("actualCostRule");
      },
    ];
  }

  calculateTimeChargingCost(action: Record<string, any>) {
    const result = calculateTimeChargingCost(action);
    this.$nextTick(() => this.validatePaymentAmounts());
    return result;
  }

  onDateChange(ev: any) {
    this.jobModel.type_id.map((item) => {
      item.next_task = item.is_periodic ? dayjs(ev).startOf('day').add(item.periodic_days, 'days').format('YYYY-MM-DD') : null;
    });
  }

  async PreviewPhotos() {
    if (Array.isArray(this.photoModel.photos)) {
      const compressedFiles = [];
      const newPhotosPreview = [];

      for (const file of this.photoModel.photos) {
        try {
          const options = installationPhotoCompressionSettings();
          const compressedFile = await imageCompression(file, options);
          compressedFiles.push(compressedFile);
          newPhotosPreview.push(URL.createObjectURL(compressedFile));
        } catch (error) {
          newPhotosPreview.push('');
        }
      }

      this.photoModel.photos = compressedFiles;
      this.photoModel.previewUrls = newPhotosPreview;
    }
  }

  updateLabel(index: number, label: any) {
    this.jobModel.expenses[index].expense_label_id = label;
  }

  get expenseLabelsCombo() {
    return commonModule.expenseLabelsCombo;
  }

}
